@if (showPreviousImageSelector) {
	<app-previous-image-selector
		table="lesson_text"
		column="image_uri"
		(onSelectImageUrl)="selectImageUri($event)"
		(onClose)="showPreviousImageSelector = false"
	></app-previous-image-selector>
}

<form [formGroup]="form" (ngSubmit)="onSubmit()">
	<app-form-title [editMode]="lesson !== undefined" model="Lesson"></app-form-title>

	<app-name-field [fg]="form" formGroupOrControlName="name"></app-name-field>

	<app-html-description-field
		[fg]="form"
		formGroupOrControlName="descriptionHtml"
		label="Description"
	></app-html-description-field>

	<app-text-field [fg]="form" formGroupOrControlName="descriptionShort" label="Short Description"></app-text-field>

	<app-text-field
		[fg]="form"
		formGroupOrControlName="imageUri"
		label="Image URI"
		[enableUpload]="true"
		accept="image/*"
		[multiple]="false"
		[directory]="false"
		[enablePrevious]="true"
		(showPrevious)="showPreviousImageSelector = true"
	></app-text-field>

	<div class="buttons">
		<button nz-button nzType="primary" type="submit" [disabled]="form.invalid">Submit</button>
		<button nz-button type="submit" (click)="clear(); $event.preventDefault()">Clear</button>
	</div>
</form>
